import type { SubscriptionDTO } from "@shared/api";
import { StatusBadge } from "./StatusBadge";
import { MiniBar } from "./MiniBar";
import { fmtDate, monthsBetween } from "../lib/format";

interface Props {
  subs: SubscriptionDTO[];
  onOpen: (id: string) => void;
}

export function SubscriptionTable({ subs, onOpen }: Props) {
  return (
    <table className="bbc-table">
      <thead>
        <tr>
          <th>Subscription</th>
          <th>Status</th>
          <th className="num">Seats</th>
          <th>Term</th>
          <th className="num">Services</th>
          <th>IP scope</th>
          <th aria-hidden="true" />
        </tr>
      </thead>
      <tbody>
        {subs.map((s) => (
          <tr
            key={s.id}
            onClick={() => onOpen(s.id)}
            className="bbc-tr-click"
          >
            <td>
              <div className="bbc-sub-name">
                <span className="bbc-sub-code mono">{s.code}</span>
                <span className="bbc-sub-title">{s.name}</span>
              </div>
            </td>
            <td>
              <StatusBadge status={s.status} />
            </td>
            <td className="num">
              <div className="bbc-cell-seats">
                <span className="mono">
                  {s.seatsUsed}/{s.seatsTotal}
                </span>
                <MiniBar
                  value={s.seatsUsed}
                  max={Math.max(1, s.seatsTotal)}
                  tone={
                    s.seatsTotal > 0 && s.seatsUsed / s.seatsTotal > 0.85
                      ? "warn"
                      : "default"
                  }
                />
              </div>
            </td>
            <td>
              <div className="bbc-cell-term">
                <span className="mono">{fmtDate(s.termEnd)}</span>
                <span className="bbc-cell-sub">
                  {monthsBetween(s.termStart, s.termEnd)} mo term
                </span>
              </div>
            </td>
            <td className="num mono">{s.services.length}</td>
            <td>
              <span className="bbc-cell-ip">{s.ipScope}</span>
            </td>
            <td className="bbc-row-arrow">→</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
